// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mergedialogTop {
    width:100%;
    height: 120px;
    background-color: blue;
}
.mergedialogBottom {
    width: 100%;
    height: 120px;
    background-color: green;
}

.mergedialoghorizontalLine {
  width: 100%;
  height: 1px;
  background-color: #666;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/mergedialog/mergedialog.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".mergedialogTop {\n    width:100%;\n    height: 120px;\n    background-color: blue;\n}\n.mergedialogBottom {\n    width: 100%;\n    height: 120px;\n    background-color: green;\n}\n\n.mergedialoghorizontalLine {\n  width: 100%;\n  height: 1px;\n  background-color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
